<div class="app-help-layout dash-container">
  <mat-nav-list class="help-nav">
    <a mat-list-item routerLink="/help" routerLinkActive="activated" [routerLinkActiveOptions]="{ exact: true }">Emergency service</a>
  </mat-nav-list>
  <div class="help-content">
    <router-outlet></router-outlet>
  </div>
</div>
